// Future Techmates — content source of truth (from live site copy)

export const LOGO =
  "https://customer-assets.emergentagent.com/job_techmates-showcase/artifacts/03bf4a83_image-removebg-preview%20%284%29.png";


export const CONTACT = {
  phone: "+91-9325684161",
  phoneHref: "tel:+919325684161",
  email: "info@futuretechmates.com",
  address: "B-660, Sushant Lok Phase I, Sector 27, Gurugram, Haryana, 122009",
  tagline: "Providing creative ideas for your business",
  socials: [
    { label: "Facebook", href: "https://www.facebook.com/", icon: "facebook" },
    { label: "Instagram", href: "https://www.instagram.com/", icon: "instagram" },
    { label: "LinkedIn", href: "https://www.linkedin.com/", icon: "linkedin" },
  ],
};

export const SERVICES = [
  {
    n: "01",
    title: "Brand Strategy & Identity",
    tag: "Build Brands with Purpose and Clarity",
    desc: "We create distinctive brand identities—logos, visuals, and brand voice—that reflect your purpose, set you apart, and connect across every touchpoint.",
    icon: "gem",
  },
  {
    n: "02",
    title: "Creative Strategy & Design",
    tag: "Ideas That Inspire, Designs That Perform",
    desc: "We deliver creative strategy and design that blends insight, storytelling, and visuals to build impactful campaigns that engage audiences and drive results.",
    icon: "palette",
  },
  {
    n: "03",
    title: "Digital Advertising & Media Buying",
    tag: "Reach the Right Audience, at the Right Time",
    desc: "We plan, buy, and optimize digital media to maximize reach, performance, and ROI across search, social, display, and video platforms.",
    icon: "target",
  },
  {
    n: "04",
    title: "SEO & Performance Marketing",
    tag: "Drive Visibility, Traffic, and Conversions",
    desc: "We drive measurable growth with SEO and performance marketing, boosting search rankings, quality traffic, leads, and ROI through data-driven strategies.",
    icon: "trending-up",
  },
  {
    n: "05",
    title: "Content & Inbound Marketing",
    tag: "Content That Attracts, Engages, and Converts",
    desc: "We create SEO-driven content and inbound marketing strategies that attract, engage, and convert the right audience across every stage of the funnel.",
    icon: "pen-tool",
  },
  {
    n: "06",
    title: "Social Media Strategy & Marketing",
    tag: "Turn Scrolls into Engagement",
    desc: "We drive brand growth with SEO-friendly social media marketing that boosts reach, engagement, and conversions across platforms.",
    icon: "megaphone",
  },
  {
    n: "07",
    title: "Public Relations & Reputation Management",
    tag: "We shape narratives that elevate credibility and build trust",
    desc: "Build trust and visibility with strategic PR & reputation management—media coverage, crisis control, and storytelling that protects your brand.",
    icon: "radio",
  },
  {
    n: "08",
    title: "Web Design, Development & Tech Solutions",
    tag: "Build Digital Experiences That Convert",
    desc: "We design high-performing, user-friendly websites that look great, follow strategy and user behavior, and turn visitors into customers.",
    icon: "code",
  },
  {
    n: "09",
    title: "Data Analytics & Performance Optimization",
    tag: "Turn Data Into Smart Decisions",
    desc: "We collect, analyze, and apply insights to guide smarter decisions, remove guesswork, and power clear growth strategies.",
    icon: "bar-chart-3",
  },
  {
    n: "10",
    title: "Offline & Experiential Marketing",
    tag: "Create Real-World Brand Experiences That Last",
    desc: "We create immersive offline and experiential campaigns that bring your brand to life, build emotional connections, and spark word-of-mouth.",
    icon: "sparkles",
  },
  {
    n: "11",
    title: "Brand Partnerships & Growth Strategy",
    tag: "Powering Growth Through Strategic Partnerships",
    desc: "We drive growth through strategic partnerships, helping brands reach new markets, audiences, and revenue with smart, win-win collaborations.",
    icon: "handshake",
  },
  {
    n: "12",
    title: "Influencer & Content Partnerships",
    tag: "Authentic Partnerships That Build Trust",
    desc: "Consumers trust people over ads. We connect brands with the right creators to build credibility, spark conversations, and drive authentic engagement.",
    icon: "users",
  },
];

export const MATES = [
  {
    letter: "M",
    title: "Mastery",
    sub: "360° Expertise That Drives Impact",
    desc: "We bring end-to-end expertise across marketing, advertising, branding, PR, digital, and technology. From strategy to execution, we deliver integrated solutions that move brands forward.",
  },
  {
    letter: "A",
    title: "Accountability",
    sub: "Transparency You Can Trust",
    desc: "We value clarity and honesty in every engagement. With structured processes, clear communication, and performance reporting, you always know where your investment is going and what it delivers.",
  },
  {
    letter: "T",
    title: "Talent",
    sub: "Creativity Meets Intelligence",
    desc: "Our team blends creative thinkers, strategists, and digital experts who turn ideas into results. We combine storytelling with data to create campaigns that connect and convert.",
  },
  {
    letter: "E",
    title: "Evolution",
    sub: "Built for What's Next",
    desc: "We bring end-to-end expertise across marketing, advertising, branding, PR, digital, and technology. From strategy to execution, we deliver integrated solutions that move brands forward.",
  },
  {
    letter: "S",
    title: "Success",
    sub: "Your Growth Is Our Scorecard",
    desc: "Your success defines ours. From scaling startups to supporting established brands, we focus on delivering measurable growth, stronger visibility, and real business impact.",
  },
];

// Placeholder target values — editable (live site ships these as 0)
export const METRICS = [
  { label: "Brands Partnered", value: 150, suffix: "+" },
  { label: "Campaigns Delivered", value: 500, suffix: "+" },
  { label: "Creative Assets Produced", value: 10000, suffix: "+" },
  { label: "Industry Verticals Served", value: 9, suffix: "+" },
  { label: "Experts", value: 40, suffix: "+" },
  { label: "Avg. ROI Growth", value: 250, suffix: "%" },
];

export const CASE_STUDIES = [
  {
    client: "Kolte-Patil Developers",
    category: "Real Estate",
    stat: "+312% qualified leads",
    title: "Turning launches into sell-outs",
    image:
      "https://images.unsplash.com/photo-1774175383227-b6baab7ab035?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    client: "Chitale Bandhu",
    category: "FMCG",
    stat: "18M+ impressions",
    title: "A heritage brand, reborn digital",
    image:
      "https://images.unsplash.com/photo-1723734820800-89bc7309acf3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    client: "FLAME University",
    category: "Education",
    stat: "2.4x application growth",
    title: "Admissions campaign that converts",
    image:
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    client: "JW Marriott",
    category: "Hospitality",
    stat: "+64% direct bookings",
    title: "Luxury storytelling, at scale",
    image:
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    client: "Bajaj Auto",
    category: "Automotive",
    stat: "40M video views",
    title: "A launch film that moved units",
    image:
      "https://images.unsplash.com/photo-1533106418989-88406c7cc8ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    client: "Ruby Hall Clinic",
    category: "Healthcare",
    stat: "+128% consultations",
    title: "Trust-first healthcare marketing",
    image:
      "https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

export const INDUSTRIES = [
  "FMCG",
  "Retail",
  "Real Estate",
  "Education",
  "Technology",
  "Hospitality",
  "Healthcare",
  "Automotive",
  "Fintech",
];

// Real client roster pulled from the live /about-us/ page — used as text logo chips
export const CLIENTS_ROW_A = [
  "Godrej Properties",
  "JW Marriott",
  "Bajaj Auto",
  "Fabindia",
  "DMart",
  "Symbiosis",
  "Quick Heal",
  "Venky's",
  "Kolte-Patil",
  "Persistent",
  "Ruby Hall Clinic",
  "Force Motors",
];

export const CLIENTS_ROW_B = [
  "Reliance Fresh",
  "Cybage",
  "Hyatt Regency",
  "Bharat Forge",
  "Shoppers Stop",
  "MIT University",
  "Suhana Masala",
  "Kalpataru",
  "Birlasoft",
  "The Ritz-Carlton",
  "Trent (Tata)",
  "Chitale Bandhu",
];

export const ABOUT = {
  intro:
    "Future TechMates is a team of marketers, storytellers, and strategists who thrive on one mission: helping brands grow in the evolving digital world. We bring together advertising, PR, and digital marketing under one roof, so you don't just get visibility, you get impact.",
  story: [
    "Every brand has a story. Ours began in 2017 with a simple belief—marketing should be bold, communication should be blunt, creativity should be beautiful, and execution should be relentlessly resilient.",
    "We started as a small team of dreamers who weren't afraid to push boundaries. No jargon, no fluff—just clear strategies, raw creativity, and campaigns that made brands impossible to ignore. Over the years, we've grown into a trusted partner for businesses of every size, across industries and continents.",
    "Today, Future TechMates stands as more than an agency—we are storytellers, strategists, and growth partners. Bold enough to challenge the norm. Blunt enough to be honest. Creative enough to turn ideas into movements. Resilient enough to never stop until success is achieved. Because at FutureTechMates, your story is our story—and we make sure it's one worth remembering.",
  ],
  quote:
    "What kept us going? Trust and Resilience. Our clients trusted us, and we matched it with the resilience to always deliver.",
  vision:
    "To become a leading digital growth partner for businesses by delivering innovative, scalable, and performance-focused marketing solutions.",
  images: [
    {
      src: "https://images.unsplash.com/photo-1552664730-d307ca884978?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      alt: "Future Techmates strategists in a creative brainstorming session",
    },
    {
      src: "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
      alt: "The team collaborating over campaign ideas",
    },
    {
      src: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
      alt: "Marketing performance planning on a whiteboard",
    },
  ],
  teamImage:
    "https://images.unsplash.com/photo-1552664730-d307ca884978?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
